export default __webpack_public_path__ + "static/media/finance.d0322a7d.png";